module.exports = __webpack_public_path__ + "static/media/favicon_baloise.31b907df.ico";